export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export const temporadas = [
  {
    id: 2,
    year: 2020,
  },
  {
    id: 3,
    year: 2021,
  },
  {
    id: 4,
    year: 2022,
  },
  {
    id: 5,
    year: 2023,
  },
  {
    id: 6,
    year: 2024,
  },
  {
    id: 7,
    year: 2025,
  },
  {
    id: 8,
    year: 2026,
  },
];
